(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ah-contact-preferences"] && !Shopify.designMode) return;
  try {
    function initializeContactPreferences(scope) {
    scope.querySelectorAll('[data-contact-preferences]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const phone = root.querySelector('input[type="tel"]');
      const hint = root.querySelector('[data-phone-hint]');
      const update = () => {
        const method = root.querySelector('input[type="radio"]:checked');
        phone.required = Boolean(method && method.value !== 'email');
        hint.textContent = phone.required ? hint.dataset.required : hint.dataset.optional;
      };
      root.addEventListener('change', update);
      update();
    });
  }
  initializeContactPreferences(document);
  document.addEventListener('shopify:section:load', (event) => initializeContactPreferences(event.target));
  } catch(e) { console.error(e); }
})();

})();
